var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSetOrgR(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.75C10.8546 4.75 11.75 3.85457 11.75 2.75C11.75 1.64543 10.8546 0.75 9.75 0.75C8.64543 0.75 7.75 1.64543 7.75 2.75C7.75 3.85457 8.64543 4.75 9.75 4.75ZM9.75 4.75V8.75M9.75 8.75C8.09315 8.75 6.75 10.0931 6.75 11.75C6.75 13.4069 8.09315 14.75 9.75 14.75C11.4069 14.75 12.75 13.4069 12.75 11.75C12.75 10.0931 11.4069 8.75 9.75 8.75ZM4.45001 15.55L7.25001 13.55M15.05 15.55L12.25 13.55M4.75 16.75C4.75 17.8546 3.85457 18.75 2.75 18.75C1.64543 18.75 0.75 17.8546 0.75 16.75C0.75 15.6454 1.64543 14.75 2.75 14.75C3.85457 14.75 4.75 15.6454 4.75 16.75ZM18.75 16.75C18.75 17.8546 17.8546 18.75 16.75 18.75C15.6454 18.75 14.75 17.8546 14.75 16.75C14.75 15.6454 15.6454 14.75 16.75 14.75C17.8546 14.75 18.75 15.6454 18.75 16.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetOrgR);
export default __webpack_public_path__ + "static/media/icon_set_orgR.a0e9bf32eb200a0315718c702a3fc882.svg";
export { ForwardRef as ReactComponent };